import { getConfig } from '@local/app-config';
import { logUnknownException, Severity } from '@local/error-logging';
import type { JSX } from 'react';
import { useEffect, useState } from 'react';

import { initializeMetrics } from './metrics';
import type { DatadogConfig, MetricsConfiguration, OpenTelemetryConfig } from './metrics.types';
import TraceProvider from './TraceProvider';

export interface MetricsWrapperProps {
    children: JSX.Element;
    datadogConfig?: DatadogConfig;
    openTelemetryConfig?: OpenTelemetryConfig;
    segmentWriteKey?: string;
}

export const MetricsWrapper = ({
    children,
    datadogConfig,
    segmentWriteKey,
    openTelemetryConfig,
}: MetricsWrapperProps) => {
    const [isInitialized, setIsInitialized] = useState(false);

    const appConfig = getConfig();
    const metricsConfig: MetricsConfiguration = {
        segmentWriteKey,
        env: appConfig?.environment,
        datadogConfig,
    };

    useEffect(() => {
        const initialize = async () => {
            if (!isInitialized) {
                try {
                    await initializeMetrics(metricsConfig);
                } catch (error) {
                    logUnknownException(error, Severity.Error);
                }

                setIsInitialized(true);
            }
        };

        initialize();
    }, [metricsConfig]);

    if (openTelemetryConfig && isInitialized) {
        return <TraceProvider openTelemetryConfig={openTelemetryConfig}>{children}</TraceProvider>;
    }

    return isInitialized ? children : null;
};
